import { render, staticRenderFns } from "./final-review.vue?vue&type=template&id=b67998ec&"
import script from "./final-review.vue?vue&type=script&lang=js&"
export * from "./final-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports